import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsCompanyViewer = {
    autoComplete: 'organization',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map